<article
  class="ticket"
  [class.t-pending]="ticket.status === 'pending'"
  [class.t-paid]="ticket.status === 'paid'"
  [class.t-confirmed]="ticket.status === 'confirmed'"
  [class.t-rejected]="ticket.status === 'rejected'"
  [class.t-expired]="ticket.status === 'expired'"
  role="article"
  aria-label="Ticket de solicitud de recarga"
>
  <!-- Header -->
  <div class="t-head">
    <div class="t-head-row">
      <app-sm-logo-white class="t-logo" [width]="92" [height]="44"></app-sm-logo-white>
      <div class="t-action">PAGAR</div>
    </div>
    <div class="t-title-block">
      <div>
        <h1 class="t-title">Solicitud de recarga</h1>
        <div class="t-sub">SUPERPAY · TICKET DE PAGO</div>
      </div>
      <div class="t-date">
        <div class="k">Fecha</div>
        <div class="v">{{ issuedDateLabel() }}</div>
      </div>
    </div>
  </div>

  <!-- Notch separator -->
  <div class="t-notch"><div class="t-dashed"></div></div>

  <!-- Body -->
  <div class="t-body">
    <div class="t-rows">
      @if (ticket.customerName || ticket.customerEmail) {
        <div class="t-row">
          <span class="k">Cliente</span>
          <span class="v">
            {{ ticket.customerName }}
            @if (ticket.customerEmail) {
              <span class="sec">{{ ticket.customerEmail }}</span>
            }
          </span>
        </div>
      }

      @if (ticket.targetAccount) {
        <div class="t-row">
          <span class="k">Cuenta a acreditar</span>
          <button
            type="button"
            class="v mono v-copy"
            (click)="copyAccount()"
            [attr.aria-label]="'Copiar cuenta ' + ticket.targetAccount"
          >
            {{ ticket.targetAccount }}
          </button>
        </div>
      }

      @if (ticket.baseAmount != null) {
        <div class="t-row">
          <span class="k">Recarga</span>
          <span class="v num">
            <span class="cur">{{ baseCurrency() }}</span>${{ formatEuro(baseAmount()) }}
          </span>
        </div>

        @if (feePercent() != null || ticket.feeAmount != null) {
          <div class="t-row">
            <span class="k">Fee{{ feePercent() != null ? ' ' + feePercent() + ' %' : '' }}</span>
            <span class="v num">
              <span class="cur">{{ baseCurrency() }}</span>${{ formatEuro(feeAmount()) }}
            </span>
          </div>
        }
      }
    </div>

    <!-- Total -->
    <div class="t-total">
      <div class="l">
        <div class="k">Monto a pagar</div>
        <div class="meta">
          <span class="chip">
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M12 2 4 5v7c0 5 3.5 9 8 10 4.5-1 8-5 8-10V5z"/>
            </svg>
            {{ networkChipLabel() }}
          </span>
        </div>
      </div>
      <div class="r">
        <div class="amt">{{ totalIntPart() }}<span class="dec">,{{ totalDecPart() }}</span></div>
        <div class="net">{{ networkSubLabel() }}</div>
      </div>
    </div>

    @if (ticket.walletAddress) {
      <button
        type="button"
        class="t-address"
        (click)="copyAddress()"
        [attr.aria-label]="'Copiar dirección ' + ticket.walletAddress"
      >
        <div class="t-address-top">
          <span class="t-address-label">Enviar a</span>
          <span class="t-address-copy" [class.copied]="copied()">
            @if (copied()) {
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m5 13 4 4L19 7"/>
              </svg>
              Copiado
            } @else {
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="9" y="9" width="13" height="13" rx="2"/>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
              </svg>
              Copiar
            }
          </span>
        </div>
        <span class="t-address-value" [title]="ticket.walletAddress">
          {{ ticket.walletAddress }}
        </span>
      </button>
    }

    @if (ticket.note) {
      <p class="t-note">{{ ticket.note }}</p>
    }
  </div>

  <!-- Footer -->
  <div class="t-foot">
    <!--
      Reference temporarily hidden — keep this block for when the backend
      starts emitting real reference codes.
      @if (ticket.reference) {
        <button type="button" class="t-ref" (click)="copyReference()" title="Copiar referencia">
          <span class="k">Referencia</span>
          <span class="v">{{ ticket.reference }}</span>
        </button>
      } @else {
        <div class="t-ref">
          <span class="k">Referencia</span>
          <span class="v">—</span>
        </div>
      }
    -->
    <div class="t-status" [attr.data-status]="ticket.status">
      <span class="pulse"></span>
      {{ statusLabel() }}
    </div>
  </div>

</article>
